import type { BestDecisionsResult } from "@beyourbest/decision-engine";

export type SnapshotDecisionOption = BestDecisionsResult["decisions"]["top"][number];

export interface DecisionMetric {
  labelKey: string;
  value: string;
}

export interface DecisionCard {
  accentColor: string;
  index: number;
  option: SnapshotDecisionOption;
}

export const SNAPSHOT_PASS_LIMIT = 3;

const GOLD_ACCENT_COLOR = "#C99A2E";
const SILVER_ACCENT_COLOR = "#9EA9B7";
const BRONZE_ACCENT_COLOR = "#BC7A52";

const GOLD_LINE_COLOR = 0xffd700;
const SILVER_LINE_COLOR = 0xc0c0c0;
const BRONZE_LINE_COLOR = 0xcd7f32;

export const CARD_ACCENT_COLORS = [GOLD_ACCENT_COLOR, SILVER_ACCENT_COLOR, BRONZE_ACCENT_COLOR];
export const DECISION_LINE_COLORS = [GOLD_LINE_COLOR, SILVER_LINE_COLOR, BRONZE_LINE_COLOR];
export const DECISION_LINE_FALLBACK_COLOR = 0xffffff;

export const formatPercentValue = (value?: number, digits = 0) => {
  const normalizedValue = Number.isFinite(value) ? (value ?? 0) : 0;
  return `${(normalizedValue * 100).toFixed(digits)}%`;
};

export const formatSignedPercentValue = (value?: number, digits = 2) => {
  const normalizedValue = Number.isFinite(value) ? (value ?? 0) : 0;
  const scaledValue = normalizedValue * 100;
  const prefix = scaledValue >= 0 ? "+" : "";
  return `${prefix}${scaledValue.toFixed(digits)}%`;
};

export const getDecisionMetrics = (option: SnapshotDecisionOption): DecisionMetric[][] => [
  [
    { labelKey: "builder.decision.metric.completion", value: formatPercentValue(option.xP) },
    { labelKey: "builder.decision.metric.threat", value: formatSignedPercentValue(option.xT, 1) },
  ],
  [
    { labelKey: "builder.decision.metric.goal.chance", value: formatPercentValue(option.xG) },
    { labelKey: "builder.decision.metric.turnover", value: formatPercentValue(option.xPT) },
  ],
];
